import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../output.css";
import { useLocation } from "react-router-dom";
import { FlightOffer } from "../../components/cards/flights";
import { CustomBreadcrumb } from "../../components/forms";
import fetchOffersQuery from "../../queries/fetchOffers";
import Airline from "../../models/Airline";
import airlinesList from "../../data/airlineslist";
import moment from "moment";
import {
  Autocomplete,
  Box,
  Slider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Accordion,
  Button,
  LoadingOverlay,
  Radio,
  TextInput,
} from "@mantine/core";
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
import Navbar from "../../components/navbar/Navbar";
import { colors } from "../../configs";
import AIRLINER from "../../assets/images/Airliner.png";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import Offer from "../../models/Offer";
import dayjs from "dayjs";
const orderByCostData = () => {
  return {
    label: "Order by Cost",
    name: "OrderByCost",
    description: "Sort by description",
    items: [
      {
        value: "Default",
        label: "Default",
      },
      {
        value: "Cheapest",
        label: "Least Expensive",
      },
      {
        value: "Expensive",
        label: "Most Expensive",
      },
    ],
  };
};
const orderByDurationData = () => {
  return {
    label: "Order by duration (Not yet)",
    name: "OrderByDuration",
    description: "Sort by duration",
    items: [
      {
        value: "Default",
        label: "Default",
      },
      {
        value: "short",
        label: "Shortest Duration",
      },
      {
        value: "long",
        label: "Longest Duration",
      },
    ],
  };
};
const filterByStopsData = () => {
  return {
    label: "Filter By Stops (Not yet)",
    name: "filterByStops",
    description: "Stops description",
    items: [
      {
        value: "All",
        label: "All",
      },
      {
        value: "0",
        label: "Direct only",
      },
      {
        value: "1",
        label: "1 stop at most",
      },
      {
        value: "2",
        label: "2 stops at most",
      },
    ],
  };
};

const airlines = () => [
  {
    value: "All airlines",
    label: "All airlines",
  },
];

type BreadType = {
  title: string;
  href: string;
  index: number;
};

const SearchResult = ({ navigation, router }: any) => {
  let location = useLocation();
  const navigate = useNavigate();

  const [flightNumber, setFlightNumber] = useState<string>("");
  const [breadcrumbData, setBreadcrumbData] = useState<any>([]);

  const [dateList, setDateList] = useState<any[]>([
    -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5,
  ]);

  const [offers, setOffers] = useState<any[] | null>(null);

  const [baseOffers, setBaseOffers] = useState<any[] | null>([]); // for reseting search filter

  const [changing, setChanging] = useState<boolean>(false);
  useState<Airline[] | null>(airlinesList);
  const [selAirline, setSelAirline] = useState<Airline | null>(null);

  const [choosenCostType, setChosenCostType] = useState<string>("Default");
  const [choosenStops, setChosenStops] = useState<any>("All");
  const [choosenDurationMode, setChoosenDurationMode] =
    useState<any>("Default");

  const [isFilterOptionReseted, setIsFilterOptionReseted] =
    useState<boolean>(false);

  const [noStop, setNoStop] = useState<boolean>(location.state.noStop);
  const [checkedLugageIn, setCheckedLugageIn] = useState<boolean>(
    location.state.checkedLugageIn
  );
  const [moreLessDay, setMoreLessDay] = useState<boolean>(
    location.state.moreLessDay
  );
  const [stopLessThree, setStopLessThree] = useState<boolean>(
    location.state.stopLessThree
  );

  const [buildQuery, setBuildQuery] = useState<any>();
  const [currentPathIdx, setCurrentPathindex] = useState<number>(0); // to be used to update the itinerary in the build query and to colored the current breadcum
  const [currentSlice, setCurrentSlice] = useState<any>(
    location.state.slices[currentPathIdx]
  ); // used to update the departure date in a slice from the choosen +- date
  const [selectedOffers, setSelectedOffers] = useState<any[]>(
    location.state.selectedOffers
  ); // selectedoffer slist based on differents choice from slice to send to checkout page
  const [trip, setTrip] = useState<string>(location.state.trip);
  const [fClass, setFClass] = useState<string>(location.state.fClass);
  const [slices, setSlices] = useState<any[]>(location.state.slices);
  const [currentDateIdx, setCurrentDateIdx] = useState<number>(0);
  const [currentDate, setCurrentDate] = useState<any>(
    slices[currentPathIdx].departure_date
  );
  const [baseDate, setBaseDate] = useState<any>(
    slices[currentPathIdx].departure_date
  );
  const updateBuildQuery = () => {
    console.error("UPDATE BUILD QUERY CALLED");

    console.log("====================================");
    console.log("current path name: " + currentPathIdx, location.state.slices);
    console.log("====================================");
    setChanging(true);
    const pathIdx = parseFloat(location.pathname.split("/")[2]);
    console.log("====================================");
    console.warn("pathIdx: ", pathIdx);
    console.log("====================================");
    setCurrentPathindex(pathIdx);

    slices[pathIdx].departure_date = currentDate;

    console.warn("UPDATED SLICES: ", slices);

    let newBuildQuery = {
      ...location.state.query,
      slices: [{ ...slices[pathIdx] }],
    };
    setBuildQuery(newBuildQuery);
  };
  // updating buildquery according to selected itinerary
  useEffect(() => {
    updateBuildQuery();
  }, [location, currentDate]);
  useEffect(() => {
    if (buildQuery) {
      getFlights();
    }
  }, [buildQuery]);

  const getFlights = () => {
    console.error("GET FLIGHTS CALLED");

    setChanging(true);
    fetchOffersQuery(buildQuery)
      .then((response: any) => response.json())
      .then((data: any) => {
        console.log("offer response in select flight ", data);
        const offers = data.data.data;
        setOffers(offers);
        setBaseOffers(offers);
        setChanging(false);
      })
      .catch((err) => {
        console.log("djedou err", err);
        setChanging(false);
      });
  };

  useEffect(() => {
    const breadData = slices.map((s: any, i: any) => {
      return {
        title: `${s.origin} to ${s.destination}`,
        href: `/flights/${i}`,
        index: i,
      };
    });

    setBreadcrumbData(breadData);
  }, [location]);
  useEffect(() => {
    console.log("OFFERs: ", offers);
    console.log("NO STOP VALUE: ", noStop);

    let newOffers: any[] = [];
    if (noStop) {
      newOffers = baseOffers!.filter(
        (offer) => offer.slices[0].segments.length < 2
      );
      setOffers(newOffers);
    }
    /*
    if (checkedLugageIn) {
       newOffers = baseOffers!.filter(
        (offer) => offer.slices[0].segments.length < 2
      );
    //  setOffers(newOffers);
    }
    if (moreLessDay) {
       newOffers = baseOffers!.filter(
        (offer) => offer.slices[0].segments.length < 2
      );
    //  setOffers(newOffers);
    }
    if (stopLessThree) {
       newOffers = baseOffers!.filter(
        (offer) => offer.slices[0].segments.length < 2
      );
    //  setOffers(newOffers);
    }
*/
    //  setOffers(newOffers);
    if (isFilterOptionReseted) {
      //  filterByAirlines(selAirline);
      //  oderByCost(choosenCostType);
      //  oderByDuration(choosenDurationMode);
      //  filterByStops(choosenStops);
    }
  }, [baseOffers]);

  const onClickBreadcrumbItems = async (event: any, href: any, index: any) => {
    event.preventDefault();

    let newBuildedQuery = {
      ...location.state.query,
      slices: [{ ...location.state.slices[index] }],
    };
    fetchOffersQuery(newBuildedQuery)
      .then((response: any) => response.json())
      .then((data: any) => {
        const offers = data.data.data;
        setOffers(offers);
      })
      .catch((err: any) => {
        console.log("Breadcum offers Error: ", err);
      });
  };
  const selectFlight = async (
    event: any,
    index: any,
    offerIndex: any,
    selectedOffer: any
  ) => {
    event.preventDefault();
    setChanging(true);
    console.log("selected offer in select flight: ", selectedOffer);
    const selOffersCopy = selectedOffers;

    selOffersCopy.push(selectedOffer);

    setSelectedOffers(selOffersCopy);

    if (currentPathIdx != slices.length - 1) {
      navigate(`/flights/${currentPathIdx + 1}`, {
        replace: true,
        state: {
          ...location.state,
          slice_index: index,
          selectedOffers: selectedOffers,
        },
      });
    } else {
      console.warn("ALL SELECTED OFFERS IN select flight: ", selectedOffers);

      navigate(`/checkout`, {
        replace: true,
        state: {
          ...location.state,
          slice_index: index,
          selectedOffers: selectedOffers,
          mainPrId: location.state.mainPrId,
        },
      });
    }
  };

  const filterByAirlines = (selAirline: Airline | null) => {
    setChanging(true);
    if (selAirline) {
      setSelAirline(selAirline);
      const newOffers = offers?.filter(
        (offer) => offer.owner.id == selAirline?.id
      )!;
      setOffers(newOffers);
    } else {
      setIsFilterOptionReseted(true);
      setSelAirline(null);

      //  setOffers(baseOffers);
    }
    setChanging(false);
  };

  const oderByCost = (direction: string) => {
    setChanging(true);
    console.log("====================================");
    console.warn("ORDER BY COST: ", direction);
    console.log("====================================");
    setChosenCostType(direction);
    let tempOffers;
    switch (direction) {
      case "Cheapest":
        tempOffers = offers?.sort((a, b) => {
          return a.total_amount - b.total_amount;
        })!;
        setOffers(tempOffers);
        break;
      case "Expensive":
        tempOffers = offers?.sort((a, b) => {
          return b.total_amount - a.total_amount;
        })!;
        setOffers(tempOffers);
        break;
      case "Default":
        setIsFilterOptionReseted(true);
        break;
      default:
        break;
    }
    setChanging(false);
  };
  const oderByDuration = (type: string) => {
    setChanging(true);
    console.log("====================================");
    console.warn("ORDER BY DURATION: ", type);
    console.log("====================================");
    setChoosenDurationMode(type);
    return;
    if (selAirline) {
      setSelAirline(selAirline);
      const newOffers = offers?.filter(
        (offer) => offer.owner.id == selAirline?.id
      )!;
      setOffers(newOffers);
    } else {
      setSelAirline(null);

      setOffers(baseOffers);
    }
    setChanging(false);
  };
  const filterByStops = (stops: any) => {
    /*
    setChanging(true);

    console.log("====================================");
    console.warn("ORDER BY STOPS: ", stops);
    console.log("====================================");
    setChosenStops(stops);

    if (stops !== "All") {
      let newOffers = offers?.filter(
        (offer) => parseFloat(stops) <= offer.slices[0].segments.length - 1
      )!;
      setOffers(newOffers);
    } else {
      setOffers(baseOffers);
    }
    setChanging(false);
    */
  };

  const updateCurrentDate = (passedDateIdx: any) => {
    setCurrentDateIdx(passedDateIdx);
    setCurrentDate(formatDate(passedDateIdx)[1]);
  };

  const formatDate = (passedDateIdx: number): any => {
    /*
    console.log("====================================");
    console.log("INDEX FROM FORMAT DATE: " + passedDateIdx, new Date(baseDate));
    console.log("====================================");
    */
    let nDate =
      new Date(baseDate).getTime() + passedDateIdx * 24 * 60 * 60 * 1000;

    let day: any = new Date(nDate).getDate();

    day = day < 10 ? `0${day}` : day;
    let month: any = new Date(nDate).getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    let year = new Date(nDate).getFullYear();
    let lastDate = `${day}/${month}`;
    // let lastDate4Search = new Date(nDate).toLocaleDateString();
    let lastDate4Search = `${year}-${month}-${day}`;

    return [lastDate, lastDate4Search];
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "200px",
          backgroundColor: "#eeeeee",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignContent: "center",
          padding: "10px 30px",
        }}>
        <Link to="/">
          <Typography
            variant="h4"
            component="span"
            sx={{
              color: colors.main,
              flex: 1,
              fontWeight: "bold",
            }}>
            <pre>Teksa Corp.</pre>
          </Typography>
        </Link>
        <Navbar />

        <img
          src={AIRLINER}
          style={{
            position: "absolute",
            width: "65%",
            zIndex: 0,
            top: "40px",
            right: "10px",
            transform: "translate(35%, -10%)",
          }}
        />
      </Box>
      <div className="pl-4 mt-4 mb-4">
        <div>
          <CustomBreadcrumb
            items={breadcrumbData}
            activeIndex={currentPathIdx}
            click={null}
          />
        </div>
        {location.state.slice_index + 1 === breadcrumbData.length ? (
          <div className="grid grid-cols-12 h-[94vh]"></div>
        ) : (
          <div className="grid grid-cols-12 h-[94vh]">
            <div className="hidden md:flex md:flex-col md:col-span-3 overflow-auto p-4">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  backgroundColor: "#eeeeee",
                  padding: "15px",
                  minHeight: "200px",
                  gap: 1,
                }}>
                <Typography variant="h5" component="h1">
                  {trip} to {"BRU"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",

                    gap: 1,
                  }}>
                  <span>ABJ</span>
                  <span>
                    <ConnectingAirportsIcon />
                  </span>
                  <span>BRU</span>
                  <span>.</span>
                  <span>Return</span>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",

                    gap: 1,
                  }}>
                  <span>22 Feb</span>
                  <span>-</span>
                  <span>9 Mar</span>
                  <span>.</span>
                  <span>1 Passager</span>
                </Box>
                <Box>{fClass}</Box>
                <Button fullWidth variant="outline" size="md">
                  Edit search
                </Button>
              </Box>
              <Radio.Group
                style={{
                  margin: "35px 0 0 0",
                  fontSize: "9px",
                  color: "#eeeeee",
                }}
                value={choosenCostType}
                onChange={(evt: any) => oderByCost(evt)}
                name={orderByCostData().name}
                label={orderByCostData().label}
                orientation="vertical"
                offset="sm"
                size="sm"
                className="mt-6"
                //description={data.description}
              >
                {orderByCostData().items.map((item, i) => (
                  <Radio
                    className="flex gap-0"
                    size="sm"
                    key={i}
                    value={item.value}
                    label={item.label}
                  />
                ))}
              </Radio.Group>
              <Radio.Group
                style={{
                  margin: "35px 0 0 0",
                  fontSize: "9px",
                  color: "#eeeeee",
                }}
                value={choosenDurationMode}
                onChange={(evt: any) => oderByDuration(evt)}
                name={orderByDurationData().name}
                label={orderByDurationData().label}
                orientation="vertical"
                offset="sm"
                size="sm"
                className="mt-6"
                //description={data.description}
              >
                {orderByDurationData().items.map((item, i) => (
                  <Radio
                    className="flex gap-0"
                    size="sm"
                    key={i}
                    value={item.value}
                    label={item.label}
                    disabled
                  />
                ))}
              </Radio.Group>
              <Radio.Group
                style={{
                  margin: "35px 0 0 0",
                  fontSize: "9px",
                  color: "#eeeeee",
                }}
                value={choosenStops}
                onChange={(evt: any) => filterByStops(evt)}
                name={filterByStopsData().name}
                label={filterByStopsData().label}
                orientation="vertical"
                offset="sm"
                size="sm"
                className="mt-6"
                //description={data.description}
              >
                {filterByStopsData().items.map((item, i) => (
                  <Radio
                    className="flex gap-0"
                    size="sm"
                    key={i}
                    value={item.value}
                    label={item.label}
                  />
                ))}
              </Radio.Group>
              <div>
                <h3
                  style={{
                    margin: "35px 0 0 0",
                    fontSize: "18px",
                    color: "#737373",
                  }}>
                  Filter by airlines
                </h3>
                <Autocomplete
                  id="country-select-demo"
                  sx={{ width: "100%" }}
                  options={airlinesList}
                  autoHighlight
                  size="small"
                  getOptionLabel={(option: Airline) => option.name}
                  value={selAirline}
                  onChange={(event: any, newValue: Airline | null) => {
                    filterByAirlines(newValue);
                  }}
                  renderOption={(props: any, option: Airline) => (
                    <Box
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}>
                      <img
                        loading="lazy"
                        width="20"
                        src={option.logo_symbol_url}
                        srcSet={`${option.logo_symbol_url} 2x`}
                        alt=""
                      />
                      {option.name}
                    </Box>
                  )}
                  renderInput={(params: any) => (
                    <TextField
                      {...params}
                      label="Airlines"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "Airlines", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              </div>
              <div>
                <TextInput
                  className="mt-4"
                  label="Flight number"
                  value={flightNumber}
                  onChange={(event) =>
                    setFlightNumber(event.currentTarget.value)
                  }
                />
              </div>
              {/*  flight hours details */}

              <Box
                sx={{
                  marginTop: "20px",
                  minHeight: "200px",
                  backgroundColor: "transparent",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around",
                  alignContent: "center",
                  padding: "10px 10px",
                }}>
                <h4>Flight time</h4>
                {/*  take off data */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    margin: 0,
                    padding: 0,
                  }}>
                  <Typography variant="body1" component="h4">
                    <FlightTakeoffIcon />
                    Take-off
                  </Typography>
                  <Typography variant="body1" component="h4">
                    At any time
                  </Typography>
                </Box>
                <Slider
                  size="small"
                  defaultValue={100}
                  aria-label="Small"
                  valueLabelDisplay="auto"
                  sx={{
                    margin: 0,
                    padding: 0,
                  }}
                />
                <Stack
                  direction="row"
                  gap="2"
                  justifyContent="space-between"
                  sx={{
                    marginBottom: "10px",
                  }}>
                  <Box>00:00</Box>
                  <Box>08:00</Box> <Box>16:00</Box> <Box>23:59</Box>
                </Stack>
                {/*  take off data */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    margin: 0,
                    padding: 0,
                  }}>
                  <Typography variant="body1" component="h4">
                    <FlightLandIcon />
                    Landing
                  </Typography>
                  <Typography variant="body1" component="h4">
                    At any time
                  </Typography>
                </Box>
                <Slider
                  size="small"
                  defaultValue={100}
                  aria-label="Small"
                  valueLabelDisplay="auto"
                  sx={{
                    margin: 0,
                    padding: 0,
                  }}
                />
                <Stack direction="row" gap="2" justifyContent="space-between">
                  <Box>00:00</Box>
                  <Box>08:00</Box> <Box>16:00</Box> <Box>23:59</Box>
                </Stack>
              </Box>
            </div>
            <div className="col-span-12 md:col-span-9 scroll-smooth mt-4 mb-4 overflow-auto p-4">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px",
                  border: "1px solid black",
                  borderRadius: "5px",
                }}>
                {dateList.map((dateIdx, idx) => (
                  <Button
                    variant="gradient"
                    color="grape"
                    sx={{
                      color: "#000000",
                      backgroundColor: colors.main,
                      padding: "5px",
                      border:
                        dateIdx === currentDateIdx
                          ? "2px solid green"
                          : "1px solid red",
                    }}
                    onClick={() => updateCurrentDate(dateIdx)}>
                    {formatDate(dateIdx)[0]}
                  </Button>
                ))}
              </Box>

              {changing ? (
                <>
                  <LoadingOverlay visible={changing} overlayBlur={2} />
                </>
              ) : (
                <>
                  <h3>{offers?.length} Vol trouvés</h3>

                  <Accordion variant="filled" chevron={false}>
                    {offers ? (
                      offers.map((o: any, i: any) => (
                        <FlightOffer
                          selectFlight={selectFlight}
                          //  nextSlice={nextSlice}
                          key={i}
                          offer={o}
                          index={i}
                        />
                      ))
                    ) : (
                      <h5>Désolé aucun vols trouvé...</h5>
                    )}
                  </Accordion>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SearchResult;
